import { render, staticRenderFns } from "./CommentFormModal.vue?vue&type=template&id=608e2493&scoped=true&"
import script from "./CommentFormModal.vue?vue&type=script&lang=js&"
export * from "./CommentFormModal.vue?vue&type=script&lang=js&"
import style0 from "./CommentFormModal.vue?vue&type=style&index=0&id=608e2493&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608e2493",
  null
  
)

export default component.exports